import { Dispatch, SetStateAction } from "react";
import { AWSCognitoUser } from "types/AWSCognito";
import { Auth } from "aws-amplify";
import { FormikValues } from "formik";
import { TFunction } from "i18next";
import styled from "styled-components";

export interface LoginProps {
  values: {
    email: string;
    password: string;
  };
}

export interface FederatedLoginProps {}

export type MessageStates = "error" | "success" | "hidden";

export type PasswordError = {
  email?: string;
  password?: string;
};

export const validatePassword = (
  values: FormikValues,
  setMessageState: (input: "error" | "success") => void,
  t: TFunction
) => {
  const errors: PasswordError = {};

  if (values.password.length < 12) {
    setMessageState("error");

    errors.password = t(
      "login.cognito.resetPassword.card.invalidPassword.feedback"
    );
  } else {
    setMessageState("success");
  }

  return errors;
};

export const ThinMessageWrapper = styled.div`
  > * {
    min-width: 200px;
  }
`;

export interface FormikFields {
  email: string;
  password: string;
}

export interface TryLogin extends LoginProps {
  persistCognitoPayload: (cognitoUser: AWSCognitoUser) => void;
  setError: Dispatch<SetStateAction<string | undefined>>;
}

export interface TryFederatedLogin extends FederatedLoginProps {
  persistCognitoPayload: (cognitoUser: AWSCognitoUser) => void;
  setError: Dispatch<SetStateAction<string | undefined>>;
}

export const tryLoginAws = async ({
  persistCognitoPayload,
  setError,
  values
}: TryLogin) => {
  try {
    const user: AWSCognitoUser = await Auth.signIn({
      username: values.email,
      password: values.password
    });

    persistCognitoPayload(user);

    return user;
  } catch (err) {
    setError((err as Error).message);
  }
};

export const tryFederatedLoginAws = async ({
  persistCognitoPayload,
  setError
}: TryFederatedLogin) => {
  try {
    const user: AWSCognitoUser = await Auth.currentAuthenticatedUser({
      bypassCache: true
    });
    console.log(user);
    persistCognitoPayload(user);

    return user;
  } catch (err) {
    setError((err as Error).message);
  }
};
